import { render, staticRenderFns } from "./SellCoinsOverview.vue?vue&type=template&id=131365e6&scoped=true&"
import script from "./SellCoinsOverview.vue?vue&type=script&lang=ts&"
export * from "./SellCoinsOverview.vue?vue&type=script&lang=ts&"
import style0 from "./SellCoinsOverview.vue?vue&type=style&index=0&id=131365e6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131365e6",
  null
  
)

export default component.exports